import { Icon } from '@/components/ui/icons';

export function ComingSoon({ name }: { name: string }) {
  return (
    <div className="animate-rise mx-auto max-w-md text-center py-24">
      <div className="mx-auto mb-5 grid place-items-center w-14 h-14 rounded-xl bg-accent text-accent-foreground">
        <Icon.spark width={24} height={24} />
      </div>
      <h2 className="text-xl font-bold text-foreground">{name}</h2>
      <p className="mt-2 text-muted-foreground">
        Part of the planned Workspace. Coming in a later release.
      </p>
    </div>
  );
}
